<template>
  <div class="col-12 component-survey-stat-wrapper" @click.prevent="emitEvent">
    <div class="component-survey-stat w-100" :class="coachColour">
      <div class="inner">
        <template v-if="kit.sampleStatus == 'MICROBIOME_COACH_SESSION_COMPLETED'">
          <i class="icon-kits"></i>
          <p>Continue your journey</p>
          <a href="#">Compare</a>
        </template>
        <template v-else>
          <i data-v-1dc42d36="" class="icon-coach"></i>
          <p>Microbiome<br/>Coach</p>
          <a href="#" v-if="kit.sampleStatus == 'RESULTS_AVAILABLE' && unlocked">Book now!</a>
          <a href="#" v-else>How to book</a>
        </template>
      </div>

    </div>

    <ModalBooking :show="showBookingModal" @close="showBookingModal = false"/>
    <ModalCoachInfo :show="showCoachInfoModal" @close="showCoachInfoModal = false" />
  </div>
</template>

<script>
import apiStringMappings from '@/mixins/apiStringMapping'
import ModalBooking from '@/components/models/ModalBooking'
import ModalCoachInfo from '@/components/models/ModalCoachInfo'

export default {
  name: 'CoachState',
  props: ['kit', 'unlocked'],
  mixins: [apiStringMappings],
  data () {
    return {
      showBookingModal: false,
      showCoachInfoModal: false
    }
  },
  components: { ModalBooking, ModalCoachInfo },
  computed: {
    coachColour () {
      if (this.kit.sampleStatus === 'MICROBIOME_COACH_SESSION_COMPLETED') {
        return 'blue'
      } else if (this.kit.sampleStatus === 'RESULTS_AVAILABLE' && this.unlocked) {
        return 'green'
      } else {
        return 'grey'
      }
    }
  },
  methods: {
    emitEvent () {
      if (this.kit.sampleStatus === 'MICROBIOME_COACH_SESSION_COMPLETED') {
        this.$router.push({ name: 'Journey' })
      } else if (this.kit.sampleStatus === 'RESULTS_AVAILABLE' && this.unlocked) {
        this.showBookingModal = true
      } else {
        this.showCoachInfoModal = true
      }
    }
  }
}
</script>

<style scoped lang="scss">
.nav-link {
  padding: 0.5rem 0;
}
  .inner{
    color: #fff;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding-top:20px;
    padding-bottom:15px;
  }
  .component-survey-stat{
    	border-radius: 4px;
    opacity: 0.9;
    cursor:pointer;

      &:hover{
       opacity: 1;
     }
  }
  .grey{
    background-color: #778598
  }
  .blue{
    background-color: #3F9FCF;
  }
  .green{
    background-color: #5CD69F;
  }

  a{
    color: #fff;
    font-size: 16px;
    font-style: italic;
    font-weight: 500;
  }
  i{
    font-size: 26px;
    color: #fff !important;
  }
  p{
    font-size: 16px;
    line-height: 18px;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/elements/CoachState.vue